import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button/button";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card/card";

const AttendanceReportsForEmployee = () => {
  return (
    <div className="p-5 flex flex-wrap gap-5">
      <Card className="w-[350px]">
        <CardHeader>
          <CardTitle>Report 1</CardTitle>
          <CardDescription>
            Monthly Employee wise Pie Chart of Attendance
          </CardDescription>
        </CardHeader>
        <CardFooter className="flex justify-between">
          <Button variant="outline" asChild size="sm">
            <Link to="/superadmin/employees/attendance-reports/report1">
              View
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AttendanceReportsForEmployee;
